<template>
	<div class='knd-loader' v-if="!loaded">
		Laden
	</div>

	<div class='story' v-if="loaded" >
		<ArticlesSwiper />
	</div>
</template>

<script>
import ArticlesSwiper from './components/video.swiper';


export default {
	name: 'App',
	data: function() {
		return {
			loaded: false
		}
	},
	mounted: function() {
		this.$store.dispatch('loadData').then(() => {
			this.loaded = true;
		})
	},
	components: {
		ArticlesSwiper,
	}
}
</script>